function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    width: "100%",
    height: "100%",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M260.389,15.824c-2.638-1.811-6.14-1.811-8.778,0c-17.636,12.11-29.21,32.405-29.21,55.415c0,23.01,11.574,43.305,29.21,55.415 c2.638,1.811,6.14,1.811,8.778,0c17.636-12.11,29.21-32.405,29.21-55.415S278.025,27.934,260.389,15.824z",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M371.758,105.7c-0.585-3.146-3.061-5.622-6.207-6.207c-21.033-3.908-43.568,2.259-59.839,18.529 c-16.271,16.271-22.437,38.805-18.529,59.839c0.584,3.146,3.061,5.622,6.207,6.207c21.034,3.908,43.568-2.259,59.839-18.529 C369.499,149.269,375.665,126.734,371.758,105.7z",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M256,236.925L256,236.925c0-13.502-5.225-26.481-14.579-36.218l-43.77-45.149",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M314.349,155.558l-43.77,45.149C261.224,210.444,256,223.422,256,236.925l0,0v62.079",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 256,
    y1: 89.508,
    x2: 256,
    y2: 228.925,
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M166.083,466.614h-37.683c-2.761,0-5-2.239-5-5v-126.69c0-2.761,2.239-5,5-5h37.683c2.762,0,5,2.239,5,5v126.69 C171.083,464.376,168.845,466.614,166.083,466.614z",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M240.031,466.614h-37.683c-2.761,0-5-2.239-5-5v-126.69c0-2.761,2.239-5,5-5h37.683c2.761,0,5,2.239,5,5v126.69 C245.031,464.376,242.793,466.614,240.031,466.614z",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M435.88,443.498h58.62c5.523,0,10-4.477,10-10V363.04c0-5.523-4.477-10-10-10h-58.62",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M149.018,153.202c-8.849-14.386-11.77-31.385-8.776-47.502c0.585-3.146,3.061-5.622,6.207-6.207 c21.033-3.908,43.568,2.259,59.839,18.529c16.271,16.271,22.437,38.805,18.53,59.839c-0.585,3.146-3.061,5.622-6.207,6.207 c-15.642,2.906-32.114,0.241-46.222-8.008",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M338.23,299.004H17.5c-5.523,0-10,4.477-10,10v178.531c0,5.523,4.477,10,10,10h407.38c5.523,0,10-4.477,10-10V309.004 c0-5.523-4.477-10-10-10h-53.963",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M97.135,431.69v29.924c0,2.761-2.239,5-5,5H54.452c-2.761,0-5-2.239-5-5v-126.69c0-2.761,2.239-5,5-5h37.683c2.761,0,5,2.239,5,5 v64.08",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBattery);
export default __webpack_public_path__ + "static/media/icon-battery.b6f037d04e04dff25b168c90ee753fa8.svg";
export { ForwardRef as ReactComponent };